function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUdisk(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#526075",
    fillRule: "evenodd",
    d: "M19.276 16.093c.465 0 .851.353.904.804l.006.106v4.092c0 .465-.353.851-.804.904l-.106.006H4.724a.913.913 0 01-.904-.804l-.006-.106v-4.092c0-.465.353-.851.804-.904l.106-.006h14.552zm-2.16 1.683c-.705 0-1.273.568-1.273 1.273s.568 1.273 1.273 1.273c.682 0 1.274-.568 1.274-1.273s-.569-1.273-1.274-1.273zm2.16-15.781c.438 0 .8.287.892.685l.018.11-.046 11.689c0 .09-.113.136-.181.068a.882.882 0 00-.567-.333l-.116-.008H4.724a.873.873 0 00-.683.34c-.058.079-.15.056-.16-.023l.001-.044V2.79a.93.93 0 01.798-.789l.112-.007h14.484zm-7.051 2.477c-.973 0-1.615.117-2.203.93.828.667 1.58 1.098 1.832 2.374l.037.229-.004-.014c-.053-.156-.493-1.266-2.4-1.785-1.25.167-2.192 1.314-2.192 2.666 0 1.323.93 2.46 2.16 2.656h.011l5.057-.01h.3c1.09-.215 1.882-1.225 1.882-2.4 0-1.03-.61-1.951-1.508-2.304-.396-1.401-1.582-2.342-2.972-2.342z"
  }));
}

SvgUdisk.clsName = 'icon-www__udisk';
SvgUdisk.remarkName = 'unknown';
export default SvgUdisk;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Udisk.js
// module id = 2464
// module chunks = 17 18